<template>
  <div>
    <infos :type="4" v-if="firstInfo" @goBackRegister="goBackRegister" @nextButton="nextFirst"></infos>
    <!-- <infos :type="4" v-if="secondInfo" @nextButton="nextSecond" @goBack="backInfo"></infos> -->
    <div class="panel-group" v-if="!firstInfo">
      <div class="panel" style="position: relative;">
        <div class="col-md-12">
          <p>Selecione as pessoas que o acompanharão na PTC 2025.</p>
          <hr>
          <p :class="{'exceededGuests': exceededGuests == true }"> {{ rankMessage }}
          </p>
          <h4>Selecione seus acompanhantes:</h4>
          <div class="checkbox" v-for="guest in guestsForFlight" :key="'regular-' + guest.id">
              <input type="checkbox" :disabled="!!guest.extra || (exceededGuests && !guest.checked)" :id="'regular' + guest.passportFirstName + guest.id" :value="guest.id"
                v-model="guests">
              <label :for="'regular' + guest.passportFirstName + guest.id" :class="guest.disable ? 'tooltip' : ''" :style="{ textDecoration: !!guest.extra || (exceededGuests && !guest.checked) ? 'line-through' : 'none' }">
                {{ guest.passportFirstName }} {{ guest.passportLastName }} - ({{ guest.formattedKinship.toUpperCase() }})
              </label>
          </div>
          <h4>Selecione seus acompanhantes extras:</h4>
          <div class="checkbox" v-for="guest in guestsForFlight" :key="'extra-' + guest.id">
              <input type="checkbox" :disabled="(guest.checked && !guest.extra) || (exceededGuestsExtras && !guest.checked) || (exceededGuests && guestsExtras.length >=1 && guest.kinship * 1 > 4 && !guest.checked)" :id="'extra' + guest.passportFirstName + guest.id" :value="guest.id"
                v-model="guestsExtras">
              <label :for="'extra' + guest.passportFirstName + guest.id" :class="guest.disable ? 'tooltip' : ''" 
                :style="{ textDecoration: (guest.checked && !guest.extra) || (exceededGuestsExtras && !guest.checked) || (exceededGuests && guestsExtras.length >=1 && guest.kinship * 1 > 4 && !guest.checked)? 'line-through' : 'none' }">
                {{ guest.passportFirstName }} {{ guest.passportLastName }} - ({{ guest.formattedKinship.toUpperCase() }})
                <span v-if="guest.extra" class="badge">Extra</span>
              </label>
              <div v-for="(checked, i) in guestsExtras" :key="`t${i}`">
              <div class="checkbox" v-if="checked === guest.id && guest.extra" style="margin-left: 30px;">
                <input type="checkbox" :id="'ticket' + guest.id" :value="guest.id" v-model="guest.ticket"
                  @click="showChoiceMsg(guest.ticket)">
                <label :for="'ticket' + guest.id">
                  <small>Deseja adquirir passagem para este passageiro?</small>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <custom-button @clicked="backButton" myText="Voltar" icon="chevron-left" pos="left" v-if="!firstInfo">
    </custom-button>
    <custom-button :disabled="loading" @clicked="changeTab" myText="Próximo" icon="chevron-right" pos="right"
      v-if="!firstInfo">
    </custom-button>
  </div>
</template>

<script>
import { mixin } from '../../mixin.js';
import Infos from '../Infos.vue';
import CustomButtom from '../shared/CustomButton.vue';
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    exceededGuests: {
      type: Boolean,
      required: true
    },
    exceededGuestsExtras: {
      type: Boolean,
      required: true
    },
    rankMessage: {
      type: String,
      required: true
    },
    guestsForFlight: {
      type: Array,
      required: false
    },
    checkedNames: {
      type: Array,
      required: false
    },
    checkedNamesExtras: {
      type: Array,
      required: false
    }
  },
  components: {
    Infos,
    'custom-button': CustomButtom
  },
  mixins: [ mixin ],
  data: function () {
    return {
      guests: this.checkedNames,
      guestsExtras: this.checkedNamesExtras,
      firstInfo: true,
      secondInfo: false,
      isLoading: this.loading,
    }
  },
  methods: {
    changeTab: function () {
      this.secondInfo = false;
      this.$emit('changeTab', 'Voo');
      this.scrollOnTop();
    },
    nextFirst: function () {
      this.firstInfo = false;
      this.secondInfo = true;
      this.scrollOnTop();
    },
    nextSecond: function () {
      this.secondInfo = false;
      this.scrollOnTop();
    },
    backInfo: function () {
      this.firstInfo = true;
      this.secondInfo = false;
      this.scrollOnTop();
    },
    backButton: function () {
      this.firstInfo = true;
      this.scrollOnTop();
    },
    showChoiceMsg: function (ticket) {
      if (!ticket) {
        this.$emit('showChoiceMsg');
      }
    },
    goBackRegister: function () {
      this.isLoading = true;
      this.$http.post(`goback-register`, { gobackRegister: 1 }).then((response) => {
        if (response.status === 200) {
          this.$router.push({ name: "register", query: { step: 'last' } });
        }
      })
    }
  },
  watch: {
    guests: {
      handler: function (val) {
        this.$emit('handleCheckedNames', val);
      },
      deep: true
    },
    guestsExtras: {
      handler: function (val) {
        this.$emit('handleCheckedNamesExtras', val);
      },
      deep: true
    },
    isLoading: function (val) {
      this.$emit("handleLoading", val);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/variables";

.exceededGuests {
  color: $alert-color;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 220px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

input[type="checkbox"][disabled="disabled"] + label {
  opacity: 0.4;
}

</style>


// WEBPACK FOOTER //
// src/components/tabs/Guests.vue